<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { reactive, ref } from 'vue';

import KTextareaField from '@/components/fields/KTextareaField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  message?: string | null;
}

export interface ValidData {
  message: string;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  if (formData.message == null) return;
  const validData: ValidData = {
    message: formData.message,
  };
  emit('submit', event, validData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.newQueryDialogForm"
    data-testid="newQueryDialogForm"
    @submit.prevent="handleSubmit"
  >
    <KTextareaField
      v-model="formData.message"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :rows="4"
      placeholder="Type here"
    />
    <input type="submit" class="hidden" :disabled="props.loading" />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newQueryDialogForm {
}
  .field {
  }
</style>
